/**
 * Created by tomers on 6/18/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/skills/skillsGridView.tmpl");
    var SkillsGridRowView = require("user-management-views/skills/SkillsGridRowView");
    var SkillsGridEmptyView = require("user-management-views/skills/SkillsGridEmptyView");

    var SkillsGridView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        SkillsGridView = Marionette.GridView.extend({
            className: "table-main ui-table",
            template: template,
            itemViewContainer: "tbody",
            itemView: SkillsGridRowView,
            emptyView: SkillsGridEmptyView,
            ui: {
                lobs: ".lobs",
                responseTime: ".response-time"
            },

            onRender: function() {
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    this.ui.lobs.removeClass("hide");
                }
                if (LE.sessionManager.hasSLAPerSkillFeature()) {
                    this.ui.responseTime.removeClass("hide");
                }
            },

            onCompositeCollectionRendered:function(){
                _.each(this.collection.getSelected(), function(selectedModel){
                    if (!_.isEmpty(this.children.findByModel(selectedModel))) {
                        selectedModel.trigger("model:selection:change", true);
                    }
                }, this);
            }
        });

    }

    LE.module("LEUserManagement", moduleDefinition);

    return SkillsGridView;
});
